const axios = require('axios');

const validateInviteCodeService = async (regMer) => {
  const apiUrl = window.spconfig?.config.apiUrl;
  const urlLink = apiUrl + "/growapi/validateinvitecode";
  return await axios.post(urlLink, JSON.stringify(regMer), {
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => {
      return response;
    },
      (error) => {
        return error;
      })
}
export default validateInviteCodeService;